import { render } from "./WorkCenterErrorDialog.vue?vue&type=template&id=1d958abe"
import script from "./WorkCenterErrorDialog.vue?vue&type=script&lang=ts"
export * from "./WorkCenterErrorDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script